import { render, staticRenderFns } from "./HelpKeyboardShortcuts.vue?vue&type=template&id=a770fde4&"
import script from "./HelpKeyboardShortcuts.vue?vue&type=script&lang=js&"
export * from "./HelpKeyboardShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports